import React, { useState } from "react";
import CoreRatioTables from "./CoreRatioTables/CoreRatioTables";
import { Box, Paper, Tab, Tabs } from "@mui/material";
import { EventNoteOutlined, MapOutlined } from "@mui/icons-material";
import JobCodeMapping from "./JobCodeMapping/JobCodeMapping";

export default function CoreRatioManagement() {
  const [tabValue, setTabValue] = useState(0);

  const fontStyles = {
    fontFamily: "Urbanist, Verdana, Arial, sans-serif",
    letterSpacing: "0.10em",
    color: "#3F5765",
  };
  const headerFontStyles = {
    ...fontStyles,
    fontWeight: "bold",
  };

  return (
    <Box sx={{ width: "100%", p: 2 }}>
      <Paper sx={{ p: 2 }}>
        <Tabs
          value={tabValue}
          onChange={(e, v) => setTabValue(v)}
          sx={{
            mb: 3,
            "& .MuiTab-root": {
              ...headerFontStyles,
              textTransform: "none",
              fontSize: "1rem",
            },
          }}
        >
          <Tab
            icon={<EventNoteOutlined />}
            iconPosition="start"
            label="Core Ratio Tables"
          />
          <Tab
            icon={<MapOutlined />}
            iconPosition="start"
            label="Job Code Mapping"
          />
        </Tabs>

        {tabValue === 0 && <CoreRatioTables />}

        {tabValue === 1 && <JobCodeMapping />}
      </Paper>
    </Box>
  );
}
